<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && itemAprovacao">
      <px-aprovacao-solicitacao-detalhes-produto-dados-basicos :item-aprovacao="itemAprovacao"
                                                               :aprovacao-id="aprovacaoId"
                                                               @update="onUpdate"/>
      <px-aprovacao-detalhes-produto-compras v-if="itemAprovacao.produto"
                                             :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-detalhes-produto-cotacoes v-if="itemAprovacao.produto"
                                              :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-detalhes-produto-estoque v-if="itemAprovacao.produto"
                                              :item-aprovacao="itemAprovacao"/>
      <px-aprovacao-produto-aprovadores :item-aprovacao="itemAprovacao"/>
    </div>
  </div>
</template>

<script>
import AprovacaoSolicitacaoDetalhesProdutoDadosBasicos
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProdutoDadosBasicos.vue';
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';

export default {
  props: {
    aprovacaoIdProp: {
      type: [String, Number],
    },
    itemIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loading: false,
      aprovacaoId: null,
      itemId: null,
      itemAprovacao: null,
    };
  },
  methods: {
    getAprovacaoProduto() {
      this.loading = true;
      AprovacaoSolicitacaoService.getProduto(this.aprovacaoId, this.itemId)
        .then(({ data }) => {
          this.itemAprovacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
      this.getAprovacaoProduto();
    },
  },
  created() {
    this.aprovacaoId = this.aprovacaoIdProp || this.$route.params.id;
    this.itemId = this.itemIdProp;
    this.getAprovacaoProduto();
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesProdutoDadosBasicos:
    AprovacaoSolicitacaoDetalhesProdutoDadosBasicos,
  },
};
</script>
